import { useState } from 'react'
import { Card, LoadMore, MoneyValue, StatusBadge, TextField } from '@shared/design-system/ui'
import { useAdminDivergencesInfinite } from '../api/admin.api'
import { TechnicalId } from './TechnicalId'
import {
  compactCell,
  filters,
  header,
  muted,
  page,
  subtitle,
  table,
  tableCard,
  tableViewport,
  td,
  th,
  title,
  titleBlock,
} from './admin.css'

export function AdminReconciliationScreen() {
  const [saleId, setSaleId] = useState('')
  const [status, setStatus] = useState('')
  const divergences = useAdminDivergencesInfinite({
    ...(saleId ? { saleId } : {}),
    ...(status ? { status } : {}),
  })
  const items = divergences.data?.pages.flatMap((page) => page.items) ?? []

  return (
    <section className={page} data-testid="reconciliation-screen">
      <div className={header}>
        <div className={titleBlock}>
          <h1 className={title}>Reconciliação</h1>
          <p className={subtitle}>
            Divergências Stripe detectadas para vendas, transferências e payouts.
          </p>
        </div>
      </div>

      <Card padding="md">
        <div className={filters}>
          <TextField
            label="Venda"
            value={saleId}
            onChange={(event) => {
              setSaleId(event.currentTarget.value)
            }}
            placeholder="saleId"
          />
          <TextField
            label="Status"
            value={status}
            onChange={(event) => {
              setStatus(event.currentTarget.value)
            }}
            placeholder="OPEN, RESOLVED..."
          />
        </div>
      </Card>

      <Card padding="none" className={tableCard}>
        <div className={tableViewport}>
          <table className={table}>
            <thead>
              <tr>
                <th className={th}>Divergência</th>
                <th className={th}>Escopo</th>
                <th className={th}>Venda</th>
                <th className={th}>Esperado</th>
                <th className={th}>Observado</th>
                <th className={th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.divergenceId}>
                  <td className={`${td} ${compactCell}`}>
                    <TechnicalId label="ID" value={item.divergenceId} />
                    <br />
                    <span className={muted}>{item.reason}</span>
                  </td>
                  <td className={td}>{item.scope}</td>
                  <td className={`${td} ${compactCell}`}>
                    {item.saleId ? <TechnicalId label="Venda" value={item.saleId} /> : 'n/a'}
                  </td>
                  <td className={td}>
                    <MoneyValue
                      amount={item.expectedAmount.amount}
                      currency={item.expectedAmount.currency}
                    />
                  </td>
                  <td className={td}>
                    {item.observedAmount ? (
                      <MoneyValue
                        amount={item.observedAmount.amount}
                        currency={item.observedAmount.currency}
                      />
                    ) : (
                      <span className={muted}>sem retorno</span>
                    )}
                  </td>
                  <td className={td}>
                    <StatusBadge
                      label={item.status}
                      tone={item.status === 'OPEN' ? 'awaiting' : 'neutral'}
                    />
                  </td>
                </tr>
              ))}
              {!divergences.isLoading && items.length === 0 ? (
                <tr>
                  <td className={td} colSpan={6}>
                    <span className={muted}>Nenhuma divergência encontrada.</span>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
        <LoadMore
          shown={items.length}
          hasMore={divergences.hasNextPage}
          loading={divergences.isFetchingNextPage}
          onClick={() => {
            void divergences.fetchNextPage()
          }}
        />
      </Card>
    </section>
  )
}
